exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".scrolled ul a {\r\n    color: #0288d1;\r\n}\r\n\r\n.scrolled {\r\n    background-color: #fff !important;\r\n    -webkit-transition: background-color 250ms linear;\r\n    transition: background-color 250ms linear;\r\n}\r\n\r\n.color {\r\n    background-color: #0288d1 ;\r\n    -webkit-transition: background-color 250ms linear;\r\n    transition: background-color 250ms linear;\r\n}\r\n\r\n.scrolled .material-icons {\r\n    color: #0288d1;\r\n}\r\n\r\n.isDisabled {\r\n    color: currentColor;\r\n    cursor: none;\r\n    opacity: 0.5;\r\n    pointer-events: none;\r\n  }", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// C:/Users/hyago/Desktop/SiteEventos/src/app/navbar/navbar.component.css
// module id = ../../../../../src/app/navbar/navbar.component.css
// module chunks = main